import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function discountedPriceValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const price = formGroup.get("price")?.value ?? formGroup.get("actualPrice")?.value;

        const discountedPrice = formGroup.get("discountedPrice")?.value;

        if (discountedPrice !== null && price !== null && discountedPrice > price) {
            return { discountedPriceInvalid: true };
        }
        return null;
    };
}
